import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import DashboardComponent from './components/organ/Dashboard';
import TicketsComponent from './components/organ/Tickets';
import NavbarComponent from './components/organ/Navbar';
import NotFoundComponent from './components/organ/NotFound';
import LoginComponent from './components/organ/Login';
import CashesComponent from './components/organ/Cashes';
import AccountsComponent from './components/organ/Accounts';
import ReportDownloadsComponent from './components/organ/ReportDownloads';
import LegalPersonComponent from './components/organ/LegalPerson';
import TicketModalComponent from './components/organ/Ticket';
import AccountsAccessComponent from './components/organ/AccountsAccess';
import AccessComponent from './components/organ/Access';
import LegalPersonsComponent from './components/organ/LegalPersons';
import DocumentComponent from './components/organ/Document';
import DocumentsComponent from './components/organ/Documents';
import RequestsComponent from './components/organ/Requests';
import SpecialPersonsComponent from './components/organ/SpecialPersons';
import SpecialPersonComponent from './components/organ/SpecialPerson';
import PostComponent from './components/organ/Post';
import PostsComponent from './components/organ/Posts';

function Organ() {
  return (
    [
      <div id="mainLoadingBox">
        <img src="/assets/organ/img/progress.gif" alt="Loading" />
      </div>
      ,
      <div className="wrapper">
        <div className="content-wrapper">
          <Router basename="/organ">
            {window.location.href.includes("organ/login") ?
              null
              : <NavbarComponent />
            }
            <Switch>
              <Route exact path='/login/' component={LoginComponent} />
              <Route exact path='/dashboard/' component={DashboardComponent} />
              <Route exact path='/report/downloads/' component={ReportDownloadsComponent} />

              <Route exact path='/tickets/new/' render={e => { return <TicketModalComponent Id={0} /> }} />
              <Route exact path='/tickets/view/:id/' render={e => { return <TicketModalComponent Id={e.match.params.id} /> }} />
              <Route exact path='/tickets/' render={e=> { return <TicketsComponent /> }} />
                            
              <Route exact path='/uni/edit/' render={e => { return <LegalPersonComponent subModuleName={"uni"} legalPersonId={-1} /> }} />
              <Route exact path='/journal/edit/' render={e => { return <LegalPersonComponent subModuleName={"journal"} legalPersonId={-1} /> }} />
              <Route exact path='/conf/edit/' render={e => { return <LegalPersonComponent subModuleName={"conf"} legalPersonId={-1} /> }} />
              
              <Route exact path='/issue/edit/t/:temp_id/' render={e => { return <LegalPersonComponent subModuleName={"issue_temp"} legalPersonId={e.match.params.temp_id} /> }} />
              <Route exact path='/issue/edit/:legal_person_id/' render={e => { return <LegalPersonComponent subModuleName={"issue"} legalPersonId={e.match.params.legal_person_id} /> }} />
              <Route exact path='/issue/new/' render={e => { return <LegalPersonComponent subModuleName={"issue"} legalPersonId={null} /> }} />

              <Route exact path='/issues/' render={e=> { return <LegalPersonsComponent subModuleName="issues" /> }} />

              <Route exact path='/persons/' render={e=> { return <SpecialPersonsComponent /> }} />
              <Route exact path='/person/edit/main/:id/' render={e=> { return <SpecialPersonComponent isMain={true} personId={e.match.params.id} /> }} />
              <Route exact path='/person/edit/:id/' render={e=> { return <SpecialPersonComponent isMain={false} personId={e.match.params.id} /> }} />
              <Route exact path='/person/new/' render={e=> { return <SpecialPersonComponent isMain={false} personId={0} /> }} />
             
              <Route exact path='/cpapers/new/' render={e => { return <DocumentComponent Id={0} subModuleName="cpapers" /> }} />
              <Route exact path='/cpapers/edit/main/:id/' render={e => { return <DocumentComponent Id={e.match.params.id} subModuleName="cpapers_main" /> }} />
              <Route exact path='/cpapers/edit/:id/' render={e => { return <DocumentComponent Id={e.match.params.id} subModuleName="cpapers" /> }} />
              <Route exact path='/cpapers/:filter/' render={e => { return <DocumentsComponent Id={e.match.params.id} subModuleName="cpapers" filter={e.match.params.filter}  /> }} />
              <Route exact path='/cpapers/' render={e => { return <DocumentsComponent Id={e.match.params.id} subModuleName="cpapers" /> }} />
              
              <Route exact path='/jpapers/new/' render={e => { return <DocumentComponent Id={0} subModuleName="jpapers" /> }} />
              <Route exact path='/jpapers/edit/main/:id/' render={e => { return <DocumentComponent Id={e.match.params.id} subModuleName="jpapers_main" /> }} />
              <Route exact path='/jpapers/edit/:id/' render={e => { return <DocumentComponent Id={e.match.params.id} subModuleName="jpapers" /> }} />
              <Route exact path='/jpapers/:filter/' render={e => { return <DocumentsComponent Id={e.match.params.id} subModuleName="jpapers" filter={e.match.params.filter}  /> }} />
              <Route exact path='/jpapers/' render={e => { return <DocumentsComponent Id={e.match.params.id} subModuleName="jpapers" /> }} />

              <Route exact path='/accounts/mobiles/newwwwwwwwwwwwwwwwwwwwwwww/' render={e => { return <AccessComponent subModuleName="accounts/mobiles" Id={0}/> }} />
              <Route exact path='/accounts/emails/newwwwwwwwwwwwwwwwwwwwwwww/' render={e => { return <AccessComponent subModuleName="accounts/emails" Id={0}/> }} />
              <Route exact path='/accounts/mobiles/edit/:id/' render={e => { return <AccessComponent subModuleName="accounts/mobiles" Id={e.match.params.id}/> }} />
              <Route exact path='/accounts/emails/edit/:id/' render={e => { return <AccessComponent subModuleName="accounts/emails" Id={e.match.params.id}/> }} />

              <Route exact path='/accounts/mobiles/:filter/' render={e => { return <AccountsAccessComponent filter={e.match.params.filter} subModuleName="accounts/mobiles" /> }} />
              <Route exact path='/accounts/mobiles/' render={e => { return <AccountsAccessComponent subModuleName="accounts/mobiles" /> }} />
              <Route exact path='/accounts/emails/:filter/' render={e => { return <AccountsAccessComponent filter={e.match.params.filter} subModuleName="accounts/emails" /> }} />
              <Route exact path='/accounts/emails/' render={e => { return <AccountsAccessComponent subModuleName="accounts/emails" /> }} />
              <Route exact path='/accounts/' render={e => { return <AccountsComponent /> }} />

              <Route exact path='/cashes/:filter/' render={e => { return <CashesComponent filter={e.match.params.filter} /> }} />
              <Route exact path='/cashes/' component={CashesComponent} />

              <Route exact path='/requests/:filter/' render={e => { return <RequestsComponent filter={e.match.params.filter} /> }} />
              <Route exact path='/requests/' component={RequestsComponent} />

              <Route exact path='/posts/new/' render={e => { return <PostComponent Id={0} subModuleName="posts" /> }} />
              <Route exact path='/posts/edit/main/:id/' render={e => { return <PostComponent Id={e.match.params.id} subModuleName="posts_main" /> }} />
              <Route exact path='/posts/edit/:id/' render={e => { return <PostComponent Id={e.match.params.id} subModuleName="posts" /> }} />
              <Route exact path='/posts/:filter/' render={e => { return <PostsComponent Id={e.match.params.id} subModuleName="posts" filter={e.match.params.filter}  /> }} />
              <Route exact path='/posts/' render={e => { return <PostsComponent Id={e.match.params.id} subModuleName="posts" /> }} />
              
              <Route exact path='/404/' component={NotFoundComponent} />
              
              <Route exact path='/' component={DashboardComponent} />
            </Switch>
          </Router>
        </div>
        <div className="control-sidebar-bg"></div>
      </div>
    ]
  );
}
export default Organ;